import Button from "./Button";

const EmptyStateCard = ({
    title,
    description,
    actionLabel,
    onAction,
    actionSlot,
    variant = "filled",
    icon,
    className = "",
    actionClassName,
    actionVariant,
}) => {
    const baseClass = variant === "bordered"
        ? "rounded-3xl border border-slate-200 bg-input-bg"
        : "rounded-3xl border border-slate-200 bg-input-bg";

    const defaultActionClass = "mt-6 w-full sm:w-auto";
    const resolvedActionVariant = actionVariant || (variant === "bordered" ? "secondary" : "primary");

    return (
        <div className={`${baseClass} ${className}`}>
            {icon ? (
                <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full border border-primary text-primary">
                    {icon}
                </div>
            ) : null}
            <p className={`mt-4 text-sm font-semibold text-slate-700 ${!icon ? "mt-0" : ""}`}>{title}</p>
            {description ? (
                <p className="mt-2 text-sm text-slate-500">
                    {description}
                </p>
            ) : null}
            {actionSlot ? actionSlot : null}
            {actionLabel && !actionSlot ? (
                <Button
                    type="button"
                    onClick={onAction}
                    variant={resolvedActionVariant}
                    className={actionClassName || defaultActionClass}
                >
                    {actionLabel}
                </Button>
            ) : null}
        </div>
    );
};

export default EmptyStateCard;
